import React from "react";
import { handleReactSlot } from "@/shared/utils/react";
import { remToPx } from "@/shared/utils/viewmode";

const ICONS_SORTED_BY = {
  ORDER: "ORDER",
  PRIORITY: "PRIORITY",
  HIDDEN_ORDER: "HIDDEN_ORDER"
};

export const renderIcons = (icons, fnHideThreeDots) => {
  return icons.map(({ render, key }) => {
    return <React.Fragment key={key}>{
      handleReactSlot(render, key, fnHideThreeDots ? { hide: fnHideThreeDots } : undefined)
    }</React.Fragment>;
  });
};

export const renderColumnIcons = (icons, maxRows = 8) => {
  const iconsArray = [];
  let currentIteration = 1;
  let totalIteration = 1;
  let currentArray = [];

  icons.forEach((icon) => {
    currentArray.push(icon);

    if (currentIteration > maxRows || icons.length === totalIteration) {
      iconsArray.push(currentArray);
      currentArray = [];
      currentIteration = 0;
    }

    currentIteration++;
    totalIteration++;
  });

  return iconsArray.map((icons, key) => {
    return (
      <div className="icons-column" key={key}>
        {renderIcons(icons)}
      </div>
    );
  });
};

export const getIconsSorted = (icons, sortedBy = ICONS_SORTED_BY.ORDER) => {
  const clonedIcons = [...icons];

  if (sortedBy === ICONS_SORTED_BY.PRIORITY) {
    clonedIcons.sort((a, b) => {
      return (a.priority ?? Infinity) > (b.priority ?? Infinity) ? 1 : -1;
    });
  } else if (sortedBy === ICONS_SORTED_BY.HIDDEN_ORDER) {
    clonedIcons.sort((a, b) => {
      return (a.hiddenOrder ?? Infinity) > (b.hiddenOrder ?? Infinity) ? 1 : -1;
    });
  } else {
    clonedIcons.sort((a, b) => {
      return (a.order ?? Infinity) > (b.order ?? Infinity) ? 1 : -1;
    });
  }

  return clonedIcons.filter((icon) => icon.isShown);
};

export const getControlPanelIcons = (icons, {
  isCollapsed, parentWidth, initialWidth, widthBtnThreeDots, defaultIconSize = remToPx(1.2 + 0.5)
}) => {
  const widthBtn3DotsFinal = initialWidth || widthBtnThreeDots || defaultIconSize;
  let currentWidth = widthBtn3DotsFinal;
  let hiddenIcons = [];
  let visibleIcons = [];

  if (isCollapsed) {
    hiddenIcons = getIconsSorted(icons, ICONS_SORTED_BY.HIDDEN_ORDER);
  } else {
    const sortedIcons = getIconsSorted(icons);
    const sortedIconsByPriority = getIconsSorted(icons, ICONS_SORTED_BY.PRIORITY);
    const clonedSortedIconsByPriority = [...sortedIconsByPriority];

    for (let i = 0; i < sortedIcons.length; i++) {
      const icon = sortedIcons[i];
      currentWidth += icon.width || defaultIconSize;
    }

    if (currentWidth >= parentWidth) {
      for (let j = 0; j < sortedIconsByPriority.length; j++) {
        const shiftedIcon = clonedSortedIconsByPriority.shift();
        if (!shiftedIcon) {
          continue;
        }

        const iconWidth = (shiftedIcon.width || defaultIconSize);
        currentWidth = currentWidth - iconWidth;
        hiddenIcons.push(shiftedIcon);

        if (currentWidth < parentWidth) {
          if (j === 0 && widthBtn3DotsFinal >= iconWidth) {
            // prevent hide an icon and show 3 dots instead,
            // that has the same or even greater width
          } else {
            break;
          }
        }
      }
    }

    if (clonedSortedIconsByPriority.length > 0) {
      visibleIcons = getIconsSorted(clonedSortedIconsByPriority);
    }

    if (hiddenIcons.length > 0) {
      hiddenIcons = getIconsSorted(hiddenIcons, ICONS_SORTED_BY.HIDDEN_ORDER);
    }
  }

  return {
    hiddenIcons,
    visibleIcons,
    showHiddenIcons: hiddenIcons.length > 0,
    showVisibleIcons: visibleIcons.length > 0,
    widthOccupied: currentWidth
  };
};

